import React, { lazy } from 'react';
import { RouteProps } from 'react-router-dom';
import { componentPagesMenu, dashboardPagesMenu, demoPagesMenu, gettingStartedPagesMenu, pageLayoutTypesPagesMenu } from '../menu';
import Login from '../pages/presentation/auth/Login';

const USER_ACCESS_RIGHTS = {
	USERACCESSRIGHTS: lazy(() => import('../pages/user-access-rights/userAccessRights')),
};

const MAIL_CONFIGURATION = {
	MAILCONFIGURATION: lazy(() => import('../pages/mail-configuration/MailConfiguration')),
};

const HOME_PAGE = {
	HOMEPAGE: lazy(() => import('../pages/presentation/home-page/HomePage')),
};

const DASHBOARD = {
	DASHBOARD: lazy(() => import('../pages/presentation/dashboard/DashboardPage')),
};

const CONTRACTS = {
	CONTRACTS: lazy(() => import('../pages/contracts/contracts')),
};

const CONTRACT_ALLOCATION = {
	CONTRACT_ALLOCATION: lazy(() => import('../pages/contract-allocation/contractAllocation')),
};

const ORDER = {
	ORDER: lazy(() => import('../pages/order/order')),
};
const PPC_DASHBOARD = {
	PPCDASHBOARD: lazy(() => import('../pages/ppc-dashboard/ppcDashboard')),
};
const PRODUCTION_DASHBOARD = {
	PRODUCTIONDASHBOARD: lazy(() => import('../pages/production-dashboard/productionDashboard')),
};
const QA_DASHBOARD = {
	QADASHBOARD: lazy(() => import('../pages/qa-dashboard/qaDashboard')),
};
const FUMIGATION_STATUS = {
	FUMIGATIONSTATUS: lazy(() => import('../pages/fumigation_status/fumigationStatus')),
};
const POST_TESTING = {
	POSTTESTING: lazy(() => import('../pages/post-testing/postTesting')),
};
const POST_FUMIGATION = {
	POSTFUMIGATION: lazy(() => import('../pages/post-fumigation/postFumigation')),
};
const PACKAGING_DASHBOARD = {
	PACKAGINGDASHBOARD: lazy(() => import('../pages/packaging-dashboard/packagingDashboard')),
};
const EXPORTS_DASHBOARD = {
	EXPORTSDASHBOARD: lazy(() => import('../pages/exports-dashboard/exportsDashboard')),
};
const EXPORTS_DOCUMENTATION = {
	EXPORTSDOCUMENTATION: lazy(() => import('../pages/exports-documentation/exportsDocumentation')),
};
const ADD_EDIT_EXPORT = {
	ADDEDITEXPORT: lazy(() => import('../pages/exports-dashboard/addEditExports')),
};
const ADD_EDIT_EXPORT_DOCUMENTATION = {
	ADDEDITEXPORTDOCUMENTATION: lazy(() => import('../pages/exports-documentation/addEditExports')),
};
// const TOOL_CUSTOMIZATION_MAIN = {
// 	TOOLCUSTOMIZATIONMAIN: lazy(() => import('../pages/tool-customization-main/tool-customization-main')),
// };

const TOOL_CUSTOMIZATION_MAIN = {
	TOOLCUSTOMIZATIONMAIN: lazy(() => import('../pages/tool-customization-main/tool-customization-main')),
};
const RICE_ALLOCATION = {
	RICEALLOCATION: lazy(() => import('../pages/rice-allocation/riceAllocation')),
};
const ORDER_DASHBOARD = {
	ORDERDASHBOARD: lazy(() => import('../pages/report/order-dashboard/orderDashboard')),
};
const ALERTS = {
	ALERTS: lazy(() => import('../pages/report/alerts/alerts')),
};
const MATERIAL_TYPE = {
	MATERIALTYPE: lazy(() => import('../pages/tool-customization/materialType/materialType')),
};
const INCOTERMS = {
	INCOTERMS: lazy(() => import('../pages/tool-customization/incoterms/incoterms')),
};
const STUFFING_PLAN = {
	STUFFINGPLAN: lazy(() => import('../pages/tool-customization/stuffing-plan/stuffingPlan')),
};
const PACK_SIZE = {
	PACKSIZE: lazy(() => import('../pages/tool-customization/pack-size/packSize')),
};
const CATEGORY = {
	CATEGORY: lazy(() => import('../pages/tool-customization/category/category')),
};
const COUNTRY = {
	COUNTRY: lazy(() => import('../pages/tool-customization/country/country')),
};
const TIMELINE_HEADING = {
	TIMELINEHEADING: lazy(() => import('../pages/tool-customization/timeline-heading/timelineHeading')),
};
const TIMELINE = {
	TIMELINE: lazy(() => import('../pages/tool-customization/timeline/timeline')),
};
const EMPLOYEES = {
	EMPLOYEES: lazy(() => import('../pages/tool-customization/employees/employees')),
};
const SELLER = {
	SELLER: lazy(() => import('../pages/tool-customization/seller/seller')),
};
const BUYER = {
	BUYER: lazy(() => import('../pages/tool-customization/buyer/buyer')),
};
// const STATE = {
// 	STATE: lazy(() => import('../pages/tool-customization/state/state')),
// };
// const CITY = {
// 	CITY: lazy(() => import('../pages/tool-customization/city/city')),
// };
const COMPANY = {
	COMPANY: lazy(() => import('../pages/tool-customization/company/company')),
};
const DESIGNATION = {
	DESIGNATION: lazy(() => import('../pages/tool-customization/designation/designation')),
};
const DOCUMENT_MASTER = {
	DOCUMENTMASTER: lazy(() => import('../pages/tool-customization/document-master/documentMaster')),
};
const DOCUMENT = {
	DOCUMENT: lazy(() => import('../pages/tool-customization/document/document')),
};
const DIVISION = {
	DIVISION: lazy(() => import('../pages/tool-customization/division/division')),
};
const UNIT_OF_MEASUREMENT = {
	UNITOFMEASUREMENT: lazy(() => import('../pages/tool-customization/unit-of-measurement/unitOfMeasurement')),
};
const RICE_ALLOCATION_LOCATION = {
	RICEALLOCATIONLOCATION: lazy(() => import('../pages/tool-customization/rice-allocation-location/riceAllocationLocation')),
};
const COMPLIANCE = {
	COMPLIANCE: lazy(() => import('../pages/tool-customization/compliance/compliance')),
};
const PESTICIDE_COMPLIANCE = {
	PESTICIDECOMPLIANCE: lazy(() => import('../pages/tool-customization/pesticide-compliance/pesticideCompliance')),
};
const PORT_MASTER = {
	PORTMASTER: lazy(() => import('../pages/tool-customization/port-master/portMaster')),
};
const PRODUCT_MASTER = {
	PRODUCTMASTER: lazy(() => import('../pages/tool-customization/productMaster/productMaster')),
};
const FG_PRODUCT_MASTER = {
	FGPRODUCTMASTER: lazy(() => import('../pages/tool-customization/fg-product/FgProductMaster')),
};
const CONTAINER_SIZE = {
	CONTAINERSIZE: lazy(() => import('../pages/tool-customization/container-size/containerSize')),
};
const SHIPPING_MODE = {
	SHIPPINGMODE: lazy(() => import('../pages/tool-customization/shippingMode/shippingMode')),
};
const SKU = {
	SKU: lazy(() => import('../pages/tool-customization/sku/sku')),
};
const PO_WISE_STATUS = {
	POWISESTATUS: lazy(() => import('../pages/report/po-wise-status/poWiseStatus')),
};
const CONTRACT_STATUS = {
	CONTRACTSTATUS: lazy(() => import('../pages/report/contract-status/contractStatus')),
};
const ORDER_STATUS = {
	ORDERSTATUS: lazy(() => import('../pages/report/order-status/orderStatus')),
};
const FUMIGATION_MASTER = {
	FUMIGATIONMASTER: lazy(() => import('../pages/tool-customization/fumigation/fumigation')),
};
const EIA_APPLICATION = {
	EIAAPPLICATION: lazy(() => import('../pages/tool-customization/eia-application/eiaApplication')),
};

const LANDING = {
	DASHBOARD: lazy(() => import('../pages/presentation/dashboard/DashboardPage')),
	DASHBOARD_BOOKING: lazy(() => import('../pages/presentation/dashboard/DashboardBookingPage')),
	SUMMARY: lazy(() => import('../pages/presentation/SummaryPage')),
	CHANGEPASSWORD: lazy(() => import('../pages/change-password/changePassword')),
};

const SINGLE = {
	BOXED: lazy(() => import('../pages/presentation/single-pages/SingleBoxedPage')),
	FLUID: lazy(() => import('../pages/presentation/single-pages/SingleFluidPage')),
};

const LIST = {
	BOXED: lazy(() => import('../pages/presentation/demo-pages/ListBoxedPage')),
	FLUID: lazy(() => import('../pages/presentation/demo-pages/ListFluidPage')),
};

const GRID = {
	BOXED: lazy(() => import('../pages/presentation/demo-pages/GridBoxedPage')),
	FLUID: lazy(() => import('../pages/presentation/demo-pages/GridFluidPage')),
};

const EDIT = {
	MODERN: lazy(() => import('../pages/presentation/demo-pages/EditModernPage')),
	BOXED: lazy(() => import('../pages/presentation/demo-pages/EditBoxedPage')),
	FLUID: lazy(() => import('../pages/presentation/demo-pages/EditFluidPage')),
	WIZARD: lazy(() => import('../pages/presentation/demo-pages/EditWizardPage')),
	IN_CANVAS: lazy(() => import('../pages/presentation/demo-pages/EditInCanvasPage')),
	IN_MODAL: lazy(() => import('../pages/presentation/demo-pages/EditInModalPage')),
};

const PRICING = {
	PRICING_TABLE: lazy(() => import('../pages/presentation/pricing/PricingTablePage')),
};

const AUTH = {
	PAGE_404: lazy(() => import('../pages/presentation/auth/Page404')),
};

const APP = {
	PROJECT_MANAGEMENT: {
		PROJECTS_LIST: lazy(() => import('../pages/presentation/project-management/ProjectManagementsList')),
		PROJECT: lazy(() => import('../pages/presentation/project-management/ProjectManagementsProject')),
	},
	KNOWLEDGE: {
		GRID: lazy(() => import('../pages/presentation/knowledge/KnowledgeGridPage')),
		VIEW: lazy(() => import('../pages/presentation/knowledge/KnowledgeViewPage')),
	},
	SALES: {
		TRANSACTIONS: lazy(() => import('../pages/presentation/sales/TransActionsPage')),
		PRODUCTS: lazy(() => import('../pages/presentation/sales/SalesListPage')),
		PRODUCTS_GRID: lazy(() => import('../pages/presentation/sales/ProductsGridPage')),
		PRODUCTS_VIEW: lazy(() => import('../pages/presentation/sales/ProductViewPage')),
	},
	APPOINTMENT: {
		CALENDAR: lazy(() => import('../pages/presentation/appointment/CalendarPage')),
		EMPLOYEE_LIST: lazy(() => import('../pages/presentation/appointment/EmployeeList')),
		EMPLOYEE_VIEW: lazy(() => import('../pages/presentation/appointment/EmployeePage')),
		APPOINTMENT_LIST: lazy(() => import('../pages/presentation/appointment/AppointmentList')),
	},
	CRM: {
		CRM_DASHBOARD: lazy(() => import('../pages/presentation/crm/CrmDashboard')),
		CUSTOMERS: lazy(() => import('../pages/presentation/crm/CustomersList')),
		CUSTOMER: lazy(() => import('../pages/presentation/crm/Customer')),
	},
	CHAT: {
		WITH_LIST: lazy(() => import('../pages/presentation/chat/WithListChatPage')),
		ONLY_LIST: lazy(() => import('../pages/presentation/chat/OnlyListChatPage')),
	},
};

const PAGE_LAYOUTS = {
	HEADER_SUBHEADER: lazy(() => import('../pages/presentation/page-layouts/HeaderAndSubheader')),
	HEADER: lazy(() => import('../pages/presentation/page-layouts/OnlyHeader')),
	SUBHEADER: lazy(() => import('../pages/presentation/page-layouts/OnlySubheader')),
	CONTENT: lazy(() => import('../pages/presentation/page-layouts/OnlyContent')),
	BLANK: lazy(() => import('../pages/presentation/page-layouts/Blank')),
	ASIDE: lazy(() => import('../pages/presentation/aside-types/DefaultAsidePage')),
	MINIMIZE_ASIDE: lazy(() => import('../pages/presentation/aside-types/MinimizeAsidePage')),
};

const CONTENT = {
	CONTENTS: lazy(() => import('../pages/documentation/content/ContentListPage')),
	TYPOGRAPHY: lazy(() => import('../pages/documentation/content/TypographyPage')),
	IMAGES: lazy(() => import('../pages/documentation/content/ImagesPage')),
	TABLES: lazy(() => import('../pages/documentation/content/TablesPage')),
	FIGURES: lazy(() => import('../pages/documentation/content/FiguresPage')),
};

const FORMS_PAGE = {
	FORMS: lazy(() => import('../pages/documentation/forms/FormsListPage')),
	FORM_GROUP: lazy(() => import('../pages/documentation/forms/FormGroupPage')),
	FORM_CONTROLS: lazy(() => import('../pages/documentation/forms/FormControlsPage')),
	SELECT: lazy(() => import('../pages/documentation/forms/SelectPage')),
	CHECKS_AND_RADIO: lazy(() => import('../pages/documentation/forms/ChecksAndRadioPage')),
	RANGE: lazy(() => import('../pages/documentation/forms/RangePage')),
	INPUT_GROUP: lazy(() => import('../pages/documentation/forms/InputGroupPage')),
	VALIDATION: lazy(() => import('../pages/documentation/forms/ValidationPage')),
	WIZARD: lazy(() => import('../pages/documentation/forms/WizardPage')),
};

const GETTING_STARTED = {
	INSTALLATION: lazy(() => import('../pages/documentation/getting-started/InstallationPage')),
	DEVELOPMENT: lazy(() => import('../pages/documentation/getting-started/DevelopmentPage')),
	FOLDER: lazy(() => import('../pages/documentation/getting-started/FolderStructurePage')),
	BOOTSTRAP: lazy(() => import('../pages/documentation/getting-started/BootstrapVariablesPage')),
	PROJECT: lazy(() => import('../pages/documentation/getting-started/ProjectStructurePage')),
};

const ROUTES = {
	ROUTER: lazy(() => import('../pages/documentation/routes/RouterPage')),
};

const COMPONENTS_PAGE = {
	COMPONENTS: lazy(() => import('../pages/documentation/components/ComponentsListPage')),
	ACCORDION: lazy(() => import('../pages/documentation/components/AccordionPage')),
	ALERT: lazy(() => import('../pages/documentation/components/AlertPage')),
	BADGE: lazy(() => import('../pages/documentation/components/BadgePage')),
	BREADCRUMB: lazy(() => import('../pages/documentation/components/BreadcrumbPage')),
	BUTTON: lazy(() => import('../pages/documentation/components/ButtonPage')),
	BUTTON_GROUP: lazy(() => import('../pages/documentation/components/ButtonGroupPage')),
	CARD: lazy(() => import('../pages/documentation/components/CardPage')),
	CAROUSEL: lazy(() => import('../pages/documentation/components/CarouselPage')),
	COLLAPSE: lazy(() => import('../pages/documentation/components/CollapsePage')),
	DROPDOWN: lazy(() => import('../pages/documentation/components/DropdownsPage')),
	LIST_GROUP: lazy(() => import('../pages/documentation/components/ListGroupPage')),
	MODAL: lazy(() => import('../pages/documentation/components/ModalPage')),
	NAVS_TABS: lazy(() => import('../pages/documentation/components/NavsTabsPage')),
	OFF_CANVAS: lazy(() => import('../pages/documentation/components/OffCanvasPage')),
	PAGINATION: lazy(() => import('../pages/documentation/components/PaginationPage')),
	POPOVERS: lazy(() => import('../pages/documentation/components/PopoversPage')),
	PROGRESS: lazy(() => import('../pages/documentation/components/ProgressPage')),
	SCROLLSPY: lazy(() => import('../pages/documentation/components/ScrollspyPage')),
	SPINNER: lazy(() => import('../pages/documentation/components/SpinnersPage')),
	TABLE: lazy(() => import('../pages/documentation/components/TablePage')),
	TOASTS: lazy(() => import('../pages/documentation/components/ToastsPage')),
	TOOLTIP: lazy(() => import('../pages/documentation/components/TooltipPage')),
};

const UTILITIES = {
	UTILITIES: lazy(() => import('../pages/documentation/utilities/UtilitiesListPage')),
	API: lazy(() => import('../pages/documentation/utilities/ApiPage')),
	BACKGROUND: lazy(() => import('../pages/documentation/utilities/BackgroundPage')),
	BORDERS: lazy(() => import('../pages/documentation/utilities/BordersPage')),
	COLORS: lazy(() => import('../pages/documentation/utilities/ColorsPage')),
	DISPLAY: lazy(() => import('../pages/documentation/utilities/DisplayPage')),
	FLEX: lazy(() => import('../pages/documentation/utilities/FlexPage')),
	FLOAT: lazy(() => import('../pages/documentation/utilities/FloatPage')),
	INTERACTIONS: lazy(() => import('../pages/documentation/utilities/InteractionsPage')),
	OVERFLOW: lazy(() => import('../pages/documentation/utilities/OverflowPage')),
	POSITION: lazy(() => import('../pages/documentation/utilities/PositionPage')),
	SHADOWS: lazy(() => import('../pages/documentation/utilities/ShadowsPage')),
	SIZING: lazy(() => import('../pages/documentation/utilities/SizingPage')),
	SPACING: lazy(() => import('../pages/documentation/utilities/SpacingPage')),
	TEXT: lazy(() => import('../pages/documentation/utilities/TextPage')),
	VERTICAL_ALIGN: lazy(() => import('../pages/documentation/utilities/VerticalAlignPage')),
	VISIBILITY: lazy(() => import('../pages/documentation/utilities/VisibilityPage')),
};

const ICONS = {
	ICONS_LIST: lazy(() => import('../pages/documentation/icons/IconsListPage')),
	ICON: lazy(() => import('../pages/documentation/icons/IconPage')),
	MATERIAL: lazy(() => import('../pages/documentation/icons/MaterialPage')),
};

const CHARTS_PAGE = {
	CHART_LIST: lazy(() => import('../pages/documentation/charts/ChartsListPage')),
	GENERAL_USAGE: lazy(() => import('../pages/documentation/charts/ChartGeneralUsagePage')),
	SPARKLINE: lazy(() => import('../pages/documentation/charts/ChartSparklinePage')),
	LINE: lazy(() => import('../pages/documentation/charts/ChartLinePage')),
	AREA: lazy(() => import('../pages/documentation/charts/ChartAreaPage')),
	COLUMN: lazy(() => import('../pages/documentation/charts/ChartColumnPage')),
	BAR: lazy(() => import('../pages/documentation/charts/ChartBarPage')),
	MIXED: lazy(() => import('../pages/documentation/charts/ChartMixedPage')),
	TIMELINE: lazy(() => import('../pages/documentation/charts/ChartTimelinePage')),
	CANDLESTICK: lazy(() => import('../pages/documentation/charts/ChartCandlestickPage')),
	BOX_WHISKER: lazy(() => import('../pages/documentation/charts/ChartBoxWhiskerPage')),
	PIE_DONUT: lazy(() => import('../pages/documentation/charts/ChartPieDonutPage')),
	RADAR: lazy(() => import('../pages/documentation/charts/ChartRadarPage')),
	POLAR: lazy(() => import('../pages/documentation/charts/ChartPolarPage')),
	RADIAL_BAR: lazy(() => import('../pages/documentation/charts/ChartRadialBarPage')),
	BUBBLE: lazy(() => import('../pages/documentation/charts/ChartBubblePage')),
	SCATTER: lazy(() => import('../pages/documentation/charts/ChartScatterPage')),
	HEAT_MAP: lazy(() => import('../pages/documentation/charts/ChartHeatMapPage')),
	TREE_MAP: lazy(() => import('../pages/documentation/charts/ChartTreeMapPage')),
};

const EXTRA = {
	NOTIFICATION: lazy(() => import('../pages/documentation/extras/NotificationPage')),
	HOOKS: lazy(() => import('../pages/documentation/extras/HooksPage')),
};

const presentation: RouteProps[] = [
	{
		path: dashboardPagesMenu.toolCustomization.subMenu.userAccessRights.path,
		element: <USER_ACCESS_RIGHTS.USERACCESSRIGHTS />,
	},
	{
		path: dashboardPagesMenu.toolCustomization.subMenu.mailConfiguration.path,
		element: <MAIL_CONFIGURATION.MAILCONFIGURATION />,
	},
	{
		path: dashboardPagesMenu.contracts.path,
		element: <CONTRACTS.CONTRACTS />,
	},
	{
		path: dashboardPagesMenu.contractAllocation.path,
		element: <CONTRACT_ALLOCATION.CONTRACT_ALLOCATION />,
	},
	{
		path: dashboardPagesMenu.order.path,
		element: <ORDER.ORDER />,
	},
	{
		path: dashboardPagesMenu.ppcDashboard.path,
		element: <PPC_DASHBOARD.PPCDASHBOARD />,
	},
	{
		path: dashboardPagesMenu.productionDashboard.path,
		element: <PRODUCTION_DASHBOARD.PRODUCTIONDASHBOARD />,
	},
	{
		path: dashboardPagesMenu.qaDashboard.path,
		element: <QA_DASHBOARD.QADASHBOARD />,
	},
	{
		path: dashboardPagesMenu.fumigationStatus.path,
		element: <FUMIGATION_STATUS.FUMIGATIONSTATUS />,
	},
	{
		path: dashboardPagesMenu.postTesting.path,
		element: <POST_TESTING.POSTTESTING />,
	},
	{
		path: dashboardPagesMenu.postFumigation.path,
		element: <POST_FUMIGATION.POSTFUMIGATION />,
	},
	{
		path: dashboardPagesMenu.packagingDashboard.path,
		element: <PACKAGING_DASHBOARD.PACKAGINGDASHBOARD />,
	},
	{
		path: dashboardPagesMenu.exportsDashboard.path,
		element: <EXPORTS_DASHBOARD.EXPORTSDASHBOARD />,
	},
	{
		path: dashboardPagesMenu.exportsDocumentation.path,
		element: <EXPORTS_DOCUMENTATION.EXPORTSDOCUMENTATION />,
	},
	{
		path: dashboardPagesMenu.addEditExport.path,
		element: <ADD_EDIT_EXPORT.ADDEDITEXPORT />,
	},
	{
		path: dashboardPagesMenu.addEditExportDocumentation.path,
		element: <ADD_EDIT_EXPORT_DOCUMENTATION.ADDEDITEXPORTDOCUMENTATION />,
	},
	{
		path: dashboardPagesMenu.riceAllocation.path,
		element: <RICE_ALLOCATION.RICEALLOCATION />,
	},
	{
		path: dashboardPagesMenu.toolCustomizationMain.path,
		element: <TOOL_CUSTOMIZATION_MAIN.TOOLCUSTOMIZATIONMAIN />,
	},
	{
		path: dashboardPagesMenu.report.subMenu.orderDashboard.path,
		element: <ORDER_DASHBOARD.ORDERDASHBOARD />,
	},
	{
		path: dashboardPagesMenu.toolCustomization.subMenu.commodity.path,
		element: <MATERIAL_TYPE.MATERIALTYPE />,
	},
	{
		path: dashboardPagesMenu.toolCustomization.subMenu.incoterms.path,
		element: <INCOTERMS.INCOTERMS />,
	},
	{
		path: dashboardPagesMenu.toolCustomization.subMenu.stuffingPlan.path,
		element: <STUFFING_PLAN.STUFFINGPLAN />,
	},
	{
		path: dashboardPagesMenu.toolCustomization.subMenu.packSize.path,
		element: <PACK_SIZE.PACKSIZE />,
	},
	{
		path: dashboardPagesMenu.toolCustomization.subMenu.category.path,
		element: <CATEGORY.CATEGORY />,
	},
	{
		path: dashboardPagesMenu.toolCustomization.subMenu.country.path,
		element: <COUNTRY.COUNTRY />,
	},
	{
		path: dashboardPagesMenu.toolCustomization.subMenu.timelineHeading.path,
		element: <TIMELINE_HEADING.TIMELINEHEADING />,
	},
	{
		path: dashboardPagesMenu.toolCustomization.subMenu.timeline.path,
		element: <TIMELINE.TIMELINE />,
	},
	{
		path: dashboardPagesMenu.toolCustomization.subMenu.employees.path,
		element: <EMPLOYEES.EMPLOYEES />,
	},
	{
		path: dashboardPagesMenu.toolCustomization.subMenu.seller.path,
		element: <SELLER.SELLER />,
	},
	{
		path: dashboardPagesMenu.toolCustomization.subMenu.buyer.path,
		element: <BUYER.BUYER />,
	},
	// {
	// 	path: dashboardPagesMenu.toolCustomization.subMenu.state.path,
	// 	element: <STATE.STATE />,
	// },
	// {
	// 	path: dashboardPagesMenu.toolCustomization.subMenu.city.path,
	// 	element: <CITY.CITY />,
	// },
	{
		path: dashboardPagesMenu.toolCustomization.subMenu.company.path,
		element: <COMPANY.COMPANY />,
	},
	{
		path: dashboardPagesMenu.toolCustomization.subMenu.designation.path,
		element: <DESIGNATION.DESIGNATION />,
	},
	{
		path: dashboardPagesMenu.toolCustomization.subMenu.documentMaster.path,
		element: <DOCUMENT_MASTER.DOCUMENTMASTER />,
	},
	{
		path: dashboardPagesMenu.toolCustomization.subMenu.document.path,
		element: <DOCUMENT.DOCUMENT />,
	},
	{
		path: dashboardPagesMenu.toolCustomization.subMenu.unitOfMeasurement.path,
		element: <UNIT_OF_MEASUREMENT.UNITOFMEASUREMENT />,
	},
	{
		path: dashboardPagesMenu.toolCustomization.subMenu.riceAllocationLocation.path,
		element: <RICE_ALLOCATION_LOCATION.RICEALLOCATIONLOCATION />,
	},
	{
		path: dashboardPagesMenu.toolCustomization.subMenu.compliance.path,
		element: <COMPLIANCE.COMPLIANCE />,
	},
	{
		path: dashboardPagesMenu.toolCustomization.subMenu.pesticideCompliance.path,
		element: <PESTICIDE_COMPLIANCE.PESTICIDECOMPLIANCE />,
	},
	{
		path: dashboardPagesMenu.toolCustomization.subMenu.portMaster.path,
		element: <PORT_MASTER.PORTMASTER />,
	},
	{
		path: dashboardPagesMenu.toolCustomization.subMenu.productMaster.path,
		element: <PRODUCT_MASTER.PRODUCTMASTER />,
	},
	{
		path: dashboardPagesMenu.toolCustomization.subMenu.fgProductMaster.path,
		element: <FG_PRODUCT_MASTER.FGPRODUCTMASTER />,
	},
	{
		path: dashboardPagesMenu.toolCustomization.subMenu.containerSize.path,
		element: <CONTAINER_SIZE.CONTAINERSIZE />,
	},
	{
		path: dashboardPagesMenu.toolCustomization.subMenu.shippingMode.path,
		element: <SHIPPING_MODE.SHIPPINGMODE />,
	},
	{
		path: dashboardPagesMenu.toolCustomization.subMenu.sku.path,
		element: <SKU.SKU />,
	},
	{
		path: dashboardPagesMenu.toolCustomization.subMenu.division.path,
		element: <DIVISION.DIVISION />,
	},
	{
		path: dashboardPagesMenu.toolCustomization.subMenu.fumigation.path,
		element: <FUMIGATION_MASTER.FUMIGATIONMASTER />,
	},
	{
		path: dashboardPagesMenu.toolCustomization.subMenu.eiaApplication.path,
		element: <EIA_APPLICATION.EIAAPPLICATION />,
	},
	{
		path: dashboardPagesMenu.report.subMenu.alerts.path,
		element: <ALERTS.ALERTS />,
	},
	{
		path: dashboardPagesMenu.report.subMenu.poWiseStatus.path,
		element: <PO_WISE_STATUS.POWISESTATUS />,
	},
	{
		path: dashboardPagesMenu.report.subMenu.contractStatus.path,
		element: <CONTRACT_STATUS.CONTRACTSTATUS />,
	},
	{
		path: dashboardPagesMenu.report.subMenu.orderStatus.path,
		element: <ORDER_STATUS.ORDERSTATUS />,
	},
	// {
	// 	path: dashboardPagesMenu.changePassword.path,
	// 	element: <LANDING.CHANGEPASSWORD />,
	// },
	{
		path: "/",
		element: <HOME_PAGE.HOMEPAGE />,
	},
	{
		path: dashboardPagesMenu.dashboard.path,
		element: <DASHBOARD.DASHBOARD />,
	},
	{
		path: pageLayoutTypesPagesMenu.dashboardBooking.path,
		element: <LANDING.DASHBOARD_BOOKING />,
	},
	{
		path: pageLayoutTypesPagesMenu.summary.path,
		element: <LANDING.SUMMARY />,
	},
	{
		path: demoPagesMenu.singlePages.subMenu.boxedSingle.path,
		element: <SINGLE.BOXED />,
	},
	{
		path: demoPagesMenu.singlePages.subMenu.fluidSingle.path,
		element: <SINGLE.FLUID />,
	},
	{
		path: demoPagesMenu.listPages.subMenu.listBoxed.path,
		element: <LIST.BOXED />,
	},
	{
		path: demoPagesMenu.listPages.subMenu.listFluid.path,
		element: <LIST.FLUID />,
	},
	{
		path: demoPagesMenu.gridPages.subMenu.gridBoxed.path,
		element: <GRID.BOXED />,
	},
	{
		path: demoPagesMenu.gridPages.subMenu.gridFluid.path,
		element: <GRID.FLUID />,
	},
	{
		path: demoPagesMenu.editPages.subMenu.editModern.path,
		element: <EDIT.MODERN />,
	},
	{
		path: demoPagesMenu.editPages.subMenu.editBoxed.path,
		element: <EDIT.BOXED />,
	},
	{
		path: demoPagesMenu.editPages.subMenu.editFluid.path,
		element: <EDIT.FLUID />,
	},
	{
		path: demoPagesMenu.editPages.subMenu.editWizard.path,
		element: <EDIT.WIZARD />,
	},
	{
		path: demoPagesMenu.editPages.subMenu.editInCanvas.path,
		element: <EDIT.IN_CANVAS />,
	},
	{
		path: demoPagesMenu.editPages.subMenu.editInModal.path,
		element: <EDIT.IN_MODAL />,
	},
	{
		path: demoPagesMenu.pricingTable.path,
		element: <PRICING.PRICING_TABLE />,
	},
	{
		path: demoPagesMenu.page404.path,
		element: <AUTH.PAGE_404 />,
	},
	{
		path: demoPagesMenu.login.path,
		element: <Login />,
	},
	{
		path: demoPagesMenu.signUp.path,
		element: <Login isSignUp />,
	},
	{
		path: demoPagesMenu.projectManagement.subMenu.list.path,
		element: <APP.PROJECT_MANAGEMENT.PROJECTS_LIST />,
	},
	{
		path: `${demoPagesMenu.projectManagement.subMenu.itemID.path}/:id`,
		element: <APP.PROJECT_MANAGEMENT.PROJECT />,
	},
	{
		path: demoPagesMenu.knowledge.subMenu.grid.path,
		element: <APP.KNOWLEDGE.GRID />,
	},
	{
		path: `${demoPagesMenu.knowledge.subMenu.itemID.path}/:id`,
		element: <APP.KNOWLEDGE.VIEW />,
	},
	{
		path: demoPagesMenu.sales.subMenu.transactions.path,
		element: <APP.SALES.TRANSACTIONS />,
	},
	{
		path: demoPagesMenu.sales.subMenu.salesList.path,
		element: <APP.SALES.PRODUCTS />,
	},
	{
		path: demoPagesMenu.sales.subMenu.productsGrid.path,
		element: <APP.SALES.PRODUCTS_GRID />,
	},
	{
		path: `${demoPagesMenu.sales.subMenu.productID.path}/:id`,
		element: <APP.SALES.PRODUCTS_VIEW />,
	},
	{
		path: demoPagesMenu.appointment.subMenu.calendar.path,
		element: <APP.APPOINTMENT.CALENDAR />,
	},
	{
		path: demoPagesMenu.appointment.subMenu.employeeList.path,
		element: <APP.APPOINTMENT.EMPLOYEE_LIST />,
	},
	{
		path: `${demoPagesMenu.appointment.subMenu.employeeID.path}/:id`,
		element: <APP.APPOINTMENT.EMPLOYEE_VIEW />,
	},
	{
		path: demoPagesMenu.appointment.subMenu.appointmentList.path,
		element: <APP.APPOINTMENT.APPOINTMENT_LIST />,
	},
	{
		path: demoPagesMenu.crm.subMenu.dashboard.path,
		element: <APP.CRM.CRM_DASHBOARD />,
	},
	{
		path: demoPagesMenu.crm.subMenu.customersList.path,
		element: <APP.CRM.CUSTOMERS />,
	},
	{
		path: `${demoPagesMenu.crm.subMenu.customerID.path}/:id`,
		element: <APP.CRM.CUSTOMER />,
	},
	{
		path: demoPagesMenu.chat.subMenu.withListChat.path,
		element: <APP.CHAT.WITH_LIST />,
	},
	{
		path: demoPagesMenu.chat.subMenu.onlyListChat.path,
		element: <APP.CHAT.ONLY_LIST />,
	},
	{
		path: pageLayoutTypesPagesMenu.blank.path,
		element: <PAGE_LAYOUTS.BLANK />,
	},
	{
		path: pageLayoutTypesPagesMenu.pageLayout.subMenu.headerAndSubheader.path,
		element: <PAGE_LAYOUTS.HEADER_SUBHEADER />,
	},
	{
		path: pageLayoutTypesPagesMenu.pageLayout.subMenu.onlyHeader.path,
		element: <PAGE_LAYOUTS.HEADER />,
	},
	{
		path: pageLayoutTypesPagesMenu.pageLayout.subMenu.onlySubheader.path,
		element: <PAGE_LAYOUTS.SUBHEADER />,
	},
	{
		path: pageLayoutTypesPagesMenu.pageLayout.subMenu.onlyContent.path,
		element: <PAGE_LAYOUTS.CONTENT />,
	},
	{
		path: pageLayoutTypesPagesMenu.asideTypes.subMenu.defaultAside.path,
		element: <PAGE_LAYOUTS.ASIDE />,
	},
	{
		path: pageLayoutTypesPagesMenu.asideTypes.subMenu.minimizeAside.path,
		element: <PAGE_LAYOUTS.MINIMIZE_ASIDE />,
	},
];

const documentation: RouteProps[] = [
	{
		path: gettingStartedPagesMenu.gettingStarted.subMenu.installation.path,
		element: <GETTING_STARTED.INSTALLATION />,
	},
	{
		path: gettingStartedPagesMenu.gettingStarted.subMenu.dev.path,
		element: <GETTING_STARTED.DEVELOPMENT />,
	},
	{
		path: gettingStartedPagesMenu.gettingStarted.subMenu.folderStructure.path,
		element: <GETTING_STARTED.FOLDER />,
	},
	{
		path: gettingStartedPagesMenu.gettingStarted.subMenu.bootstrapVariables.path,
		element: <GETTING_STARTED.BOOTSTRAP />,
	},
	{
		path: gettingStartedPagesMenu.gettingStarted.subMenu.projectStructure.path,
		element: <GETTING_STARTED.PROJECT />,
	},
	{
		path: gettingStartedPagesMenu.routes.subMenu.router.path,
		element: <ROUTES.ROUTER />,
	},
	{
		path: componentPagesMenu.content.path,
		element: <CONTENT.CONTENTS />,
	},
	{
		path: componentPagesMenu.content.subMenu.typography.path,
		element: <CONTENT.TYPOGRAPHY />,
	},
	{
		path: componentPagesMenu.content.subMenu.images.path,
		element: <CONTENT.IMAGES />,
	},
	{
		path: componentPagesMenu.content.subMenu.tables.path,
		element: <CONTENT.TABLES />,
	},
	{
		path: componentPagesMenu.content.subMenu.figures.path,
		element: <CONTENT.FIGURES />,
	},
	{
		path: componentPagesMenu.forms.path,
		element: <FORMS_PAGE.FORMS />,
	},
	{
		path: componentPagesMenu.forms.subMenu.formGroup.path,
		element: <FORMS_PAGE.FORM_GROUP />,
	},
	{
		path: componentPagesMenu.forms.subMenu.formControl.path,
		element: <FORMS_PAGE.FORM_CONTROLS />,
	},
	{
		path: componentPagesMenu.forms.subMenu.select.path,
		element: <FORMS_PAGE.SELECT />,
	},
	{
		path: componentPagesMenu.forms.subMenu.checksAndRadio.path,
		element: <FORMS_PAGE.CHECKS_AND_RADIO />,
	},
	{
		path: componentPagesMenu.forms.subMenu.range.path,
		element: <FORMS_PAGE.RANGE />,
	},
	{
		path: componentPagesMenu.forms.subMenu.inputGroup.path,
		element: <FORMS_PAGE.INPUT_GROUP />,
	},
	{
		path: componentPagesMenu.forms.subMenu.validation.path,
		element: <FORMS_PAGE.VALIDATION />,
	},
	{
		path: componentPagesMenu.forms.subMenu.wizard.path,
		element: <FORMS_PAGE.WIZARD />,
	},
	{
		path: componentPagesMenu.components.path,
		element: <COMPONENTS_PAGE.COMPONENTS />,
	},
	{
		path: componentPagesMenu.components.subMenu.tooltip.path,
		element: <COMPONENTS_PAGE.TOOLTIP />,
	},
	{
		path: componentPagesMenu.components.subMenu.toasts.path,
		element: <COMPONENTS_PAGE.TOASTS />,
	},
	{
		path: componentPagesMenu.components.subMenu.scrollspy.path,
		element: <COMPONENTS_PAGE.SCROLLSPY />,
	},
	{
		path: componentPagesMenu.components.subMenu.carousel.path,
		element: <COMPONENTS_PAGE.CAROUSEL />,
	},
	{
		path: componentPagesMenu.components.subMenu.spinners.path,
		element: <COMPONENTS_PAGE.SPINNER />,
	},
	{
		path: componentPagesMenu.components.subMenu.listGroup.path,
		element: <COMPONENTS_PAGE.LIST_GROUP />,
	},
	{
		path: componentPagesMenu.components.subMenu.breadcrumb.path,
		element: <COMPONENTS_PAGE.BREADCRUMB />,
	},
	{
		path: componentPagesMenu.components.subMenu.collapse.path,
		element: <COMPONENTS_PAGE.COLLAPSE />,
	},
	{
		path: componentPagesMenu.components.subMenu.pagination.path,
		element: <COMPONENTS_PAGE.PAGINATION />,
	},
	{
		path: componentPagesMenu.components.subMenu.progress.path,
		element: <COMPONENTS_PAGE.PROGRESS />,
	},
	{
		path: componentPagesMenu.components.subMenu.card.path,
		element: <COMPONENTS_PAGE.CARD />,
	},
	{
		path: componentPagesMenu.components.subMenu.button.path,
		element: <COMPONENTS_PAGE.BUTTON />,
	},
	{
		path: componentPagesMenu.components.subMenu.buttonGroup.path,
		element: <COMPONENTS_PAGE.BUTTON_GROUP />,
	},
	{
		path: componentPagesMenu.components.subMenu.alert.path,
		element: <COMPONENTS_PAGE.ALERT />,
	},
	{
		path: componentPagesMenu.components.subMenu.badge.path,
		element: <COMPONENTS_PAGE.BADGE />,
	},
	{
		path: componentPagesMenu.components.subMenu.popovers.path,
		element: <COMPONENTS_PAGE.POPOVERS />,
	},
	{
		path: componentPagesMenu.components.subMenu.dropdowns.path,
		element: <COMPONENTS_PAGE.DROPDOWN />,
	},
	{
		path: componentPagesMenu.components.subMenu.accordion.path,
		element: <COMPONENTS_PAGE.ACCORDION />,
	},
	{
		path: componentPagesMenu.components.subMenu.modal.path,
		element: <COMPONENTS_PAGE.MODAL />,
	},
	{
		path: componentPagesMenu.components.subMenu.navsTabs.path,
		element: <COMPONENTS_PAGE.NAVS_TABS />,
	},
	{
		path: componentPagesMenu.components.subMenu.offcanvas.path,
		element: <COMPONENTS_PAGE.OFF_CANVAS />,
	},
	{
		path: componentPagesMenu.components.subMenu.table.path,
		element: <COMPONENTS_PAGE.TABLE />,
	},
	{
		path: componentPagesMenu.utilities.path,
		element: <UTILITIES.UTILITIES />,
	},
	{
		path: componentPagesMenu.utilities.subMenu.api.path,
		element: <UTILITIES.API />,
	},
	{
		path: componentPagesMenu.utilities.subMenu.background.path,
		element: <UTILITIES.BACKGROUND />,
	},
	{
		path: componentPagesMenu.utilities.subMenu.borders.path,
		element: <UTILITIES.BORDERS />,
	},
	{
		path: componentPagesMenu.utilities.subMenu.colors.path,
		element: <UTILITIES.COLORS />,
	},
	{
		path: componentPagesMenu.utilities.subMenu.display.path,
		element: <UTILITIES.DISPLAY />,
	},
	{
		path: componentPagesMenu.utilities.subMenu.flex.path,
		element: <UTILITIES.FLEX />,
	},
	{
		path: componentPagesMenu.utilities.subMenu.float.path,
		element: <UTILITIES.FLOAT />,
	},
	{
		path: componentPagesMenu.utilities.subMenu.interactions.path,
		element: <UTILITIES.INTERACTIONS />,
	},
	{
		path: componentPagesMenu.utilities.subMenu.overflow.path,
		element: <UTILITIES.OVERFLOW />,
	},
	{
		path: componentPagesMenu.utilities.subMenu.position.path,
		element: <UTILITIES.POSITION />,
	},
	{
		path: componentPagesMenu.utilities.subMenu.shadows.path,
		element: <UTILITIES.SHADOWS />,
	},
	{
		path: componentPagesMenu.utilities.subMenu.sizing.path,
		element: <UTILITIES.SIZING />,
	},
	{
		path: componentPagesMenu.utilities.subMenu.spacing.path,
		element: <UTILITIES.SPACING />,
	},
	{
		path: componentPagesMenu.utilities.subMenu.text.path,
		element: <UTILITIES.TEXT />,
	},
	{
		path: componentPagesMenu.utilities.subMenu.verticalAlign.path,
		element: <UTILITIES.VERTICAL_ALIGN />,
	},
	{
		path: componentPagesMenu.utilities.subMenu.visibility.path,
		element: <UTILITIES.VISIBILITY />,
	},
	{
		path: componentPagesMenu.icons.path,
		element: <ICONS.ICONS_LIST />,
	},
	{
		path: componentPagesMenu.icons.subMenu.icon.path,
		element: <ICONS.ICON />,
	},
	{
		path: componentPagesMenu.icons.subMenu.material.path,
		element: <ICONS.MATERIAL />,
	},
	{
		path: componentPagesMenu.charts.path,
		element: <CHARTS_PAGE.CHART_LIST />,
	},
	{
		path: componentPagesMenu.charts.subMenu.chartsUsage.path,
		element: <CHARTS_PAGE.GENERAL_USAGE />,
	},
	{
		path: componentPagesMenu.charts.subMenu.chartsSparkline.path,
		element: <CHARTS_PAGE.SPARKLINE />,
	},
	{
		path: componentPagesMenu.charts.subMenu.chartsLine.path,
		element: <CHARTS_PAGE.LINE />,
	},
	{
		path: componentPagesMenu.charts.subMenu.chartsArea.path,
		element: <CHARTS_PAGE.AREA />,
	},
	{
		path: componentPagesMenu.charts.subMenu.chartsColumn.path,
		element: <CHARTS_PAGE.COLUMN />,
	},
	{
		path: componentPagesMenu.charts.subMenu.chartsBar.path,
		element: <CHARTS_PAGE.BAR />,
	},
	{
		path: componentPagesMenu.charts.subMenu.chartsMixed.path,
		element: <CHARTS_PAGE.MIXED />,
	},
	{
		path: componentPagesMenu.charts.subMenu.chartsTimeline.path,
		element: <CHARTS_PAGE.TIMELINE />,
	},
	{
		path: componentPagesMenu.charts.subMenu.chartsCandleStick.path,
		element: <CHARTS_PAGE.CANDLESTICK />,
	},
	{
		path: componentPagesMenu.charts.subMenu.chartsBoxWhisker.path,
		element: <CHARTS_PAGE.BOX_WHISKER />,
	},
	{
		path: componentPagesMenu.charts.subMenu.chartsPieDonut.path,
		element: <CHARTS_PAGE.PIE_DONUT />,
	},
	{
		path: componentPagesMenu.charts.subMenu.chartsRadar.path,
		element: <CHARTS_PAGE.RADAR />,
	},
	{
		path: componentPagesMenu.charts.subMenu.chartsPolar.path,
		element: <CHARTS_PAGE.POLAR />,
	},
	{
		path: componentPagesMenu.charts.subMenu.chartsRadialBar.path,
		element: <CHARTS_PAGE.RADIAL_BAR />,
	},
	{
		path: componentPagesMenu.charts.subMenu.chartsBubble.path,
		element: <CHARTS_PAGE.BUBBLE />,
	},
	{
		path: componentPagesMenu.charts.subMenu.chartsScatter.path,
		element: <CHARTS_PAGE.SCATTER />,
	},
	{
		path: componentPagesMenu.charts.subMenu.chartsHeatMap.path,
		element: <CHARTS_PAGE.HEAT_MAP />,
	},
	{
		path: componentPagesMenu.charts.subMenu.chartsTreeMap.path,
		element: <CHARTS_PAGE.TREE_MAP />,
	},
	{
		path: componentPagesMenu.notification.path,
		element: <EXTRA.NOTIFICATION />,
	},
	{
		path: componentPagesMenu.hooks.path,
		element: <EXTRA.HOOKS />,
	},
];

const contents = [...presentation, ...documentation];

export default contents;
